<template>
  <UiComponentWrapper
    v-once
    ref="$root"
    class="value-proposition"
  >
    <UiComponentContainer class="inner">
      <UiComponentWrapper class="hero">
        <UiComponentHeading :level="2">
          {{ data.componentValueProposition.title }}
        </UiComponentHeading>
        <UiComponentParagraph>{{ data.componentValueProposition.text }}</UiComponentParagraph>
        <UiComponentWrapper class="actions">
          <AtomButton
            :action="signupOrUpgradeCallToAction.action"
            label="LS Value Proposition section CTA"
            size="l"
            :to="signupOrUpgradeCallToAction.to"
          >
            {{ signupOrUpgradeCallToAction.slot }}
          </AtomButton>
          <AtomButton
            :action="requestDemoCallToAction.action"
            label="LS Value Proposition section CTA"
            size="l"
            :to="requestDemoCallToAction.to"
            type="secondary"
          >
            {{ requestDemoCallToAction.slot }}
          </AtomButton>
        </UiComponentWrapper>
      </UiComponentWrapper>
      <UiComponentWrapper
        class="benefits"
        :style="{ '--timer': `${timer}%` }"
      >
        <UiComponentWrapper
          class="benefit your-trusted-european-alternative"
          :class="{ active: currentIndex === 0 }"
        >
          <UiComponentWrapper
            class="headline"
            @click="onClick(0)"
            @mouseenter="onMouseEnter(0)"
            @mouseleave="onMouseLeave"
          >
            <UiComponentHeading :level="3">
              {{ data.componentValueProposition.macroBenefit1Title }}
            </UiComponentHeading>
            <UiComponentParagraph>{{ data.componentValueProposition.macroBenefit1Text }}</UiComponentParagraph>
          </UiComponentWrapper>
          <UiComponentWrapper class="features">
            <UiComponentImage
              :alt="data.componentValueProposition.macroBenefit1Background.alt"
              class="map"
              :expected-size="535"
              :height="data.componentValueProposition.macroBenefit1Background.height"
              :source="data.componentValueProposition.macroBenefit1Background.url"
              :width="data.componentValueProposition.macroBenefit1Background.width"
            />
            <UiComponentWrapper class="feature">
              <UiComponentHeading :level="4">
                {{ data.componentValueProposition.macroBenefit1Feature1Title }}
              </UiComponentHeading>
              <UiComponentParagraph>{{ data.componentValueProposition.macroBenefit1Feature1Text }}</UiComponentParagraph>
              <UiComponentWrapper class="certifications">
                <UiComponentWrapper class="badge gdpr">
                  <UiComponentImage
                    :alt="data.componentValueProposition.macroBenefit1Feature1GdprBadge.alt"
                    :expected-size="72"
                    :height="data.componentValueProposition.macroBenefit1Feature1GdprBadge.height"
                    :source="data.componentValueProposition.macroBenefit1Feature1GdprBadge.url"
                    :width="data.componentValueProposition.macroBenefit1Feature1GdprBadge.width"
                  />
                  <UiComponentParagraph>{{ data.componentValueProposition.macroBenefit1Feature1GdprText }}</UiComponentParagraph>
                </UiComponentWrapper>
                <UiComponentWrapper class="badge iso-27001">
                  <UiComponentImage
                    :alt="data.componentValueProposition.macroBenefit1Feature1Iso27001Badge.alt"
                    :expected-size="72"
                    :height="data.componentValueProposition.macroBenefit1Feature1Iso27001Badge.height"
                    :source="data.componentValueProposition.macroBenefit1Feature1Iso27001Badge.url"
                    :width="data.componentValueProposition.macroBenefit1Feature1Iso27001Badge.width"
                  />
                  <UiComponentParagraph>{{ data.componentValueProposition.macroBenefit1Feature1Iso27001Text }}</UiComponentParagraph>
                </UiComponentWrapper>
              </UiComponentWrapper>
            </UiComponentWrapper>
            <UiComponentWrapper class="feature">
              <UiComponentHeading :level="4">
                {{ data.componentValueProposition.macroBenefit1Feature2Title }}
              </UiComponentHeading>
              <UiComponentParagraph>{{ data.componentValueProposition.macroBenefit1Feature2Text }}</UiComponentParagraph>
              <UiComponentWrapper class="support">
                <UiComponentWrapper class="csat">
                  <UiComponentWrapper class="value">
                    <UiComponentParagraph>{{ data.componentValueProposition.macroBenefit1Feature2CsatText }}</UiComponentParagraph>
                    <UiComponentParagraph>{{ data.componentValueProposition.macroBenefit1Feature2CsatValue }}</UiComponentParagraph>
                  </UiComponentWrapper>
                  <UiComponentWrapper class="bar">
                    <svg
                      class="cursor"
                      xmlns="http://www.w3.org/2000/svg"
                      width="13"
                      height="11"
                      viewBox="0 0 13 11"
                      fill="none"
                    >
                      <path
                        d="M7.10835 10.3328C6.69485 10.9821 5.73351 10.9403 5.37794 10.2576L0.977717 1.80844C0.622144 1.12568 1.13902 0.314036 1.90809 0.34748L11.4254 0.761348C12.1945 0.794792 12.6389 1.64824 12.2254 2.29756L7.10835 10.3328Z"
                        fill="#2EB89A"
                      />
                    </svg>
                  </UiComponentWrapper>
                </UiComponentWrapper>
                <UiComponentWrapper class="nps">
                  <UiComponentWrapper class="value">
                    <UiComponentParagraph>{{ data.componentValueProposition.macroBenefit1Feature2NpsText }}</UiComponentParagraph>
                    <UiComponentParagraph>{{ data.componentValueProposition.macroBenefit1Feature2NpsValue }}</UiComponentParagraph>
                  </UiComponentWrapper>
                  <UiComponentWrapper class="bar">
                    <svg
                      class="cursor"
                      xmlns="http://www.w3.org/2000/svg"
                      width="13"
                      height="11"
                      viewBox="0 0 13 11"
                      fill="none"
                    >
                      <path
                        d="M7.10835 10.3328C6.69485 10.9821 5.73351 10.9403 5.37794 10.2576L0.977717 1.80844C0.622144 1.12568 1.13902 0.314036 1.90809 0.34748L11.4254 0.761348C12.1945 0.794792 12.6389 1.64824 12.2254 2.29756L7.10835 10.3328Z"
                        fill="#2EB89A"
                      />
                    </svg>
                  </UiComponentWrapper>
                </UiComponentWrapper>
                <UiComponentWrapper class="uptime">
                  <UiComponentWrapper class="value">
                    <UiComponentParagraph>{{ data.componentValueProposition.macroBenefit1Feature2UptimeValue }}</UiComponentParagraph>
                    <UiComponentParagraph>{{ data.componentValueProposition.macroBenefit1Feature2UptimeText }}</UiComponentParagraph>
                  </UiComponentWrapper>
                  <UiComponentWrapper class="graph">
                    <UiComponentWrapper
                      v-for="n in 27"
                      :key="`bar-${n}`"
                      class="bar"
                    />
                  </UiComponentWrapper>
                </UiComponentWrapper>
              </UiComponentWrapper>
            </UiComponentWrapper>
          </UiComponentWrapper>
        </UiComponentWrapper>
        <UiComponentWrapper
          class="benefit mastering-engagements"
          :class="{ active: currentIndex === 1 }"
        >
          <UiComponentWrapper
            class="headline"
            @click="onClick(1)"
            @mouseenter="onMouseEnter(1)"
            @mouseleave="onMouseLeave"
          >
            <UiComponentHeading :level="3">
              {{ data.componentValueProposition.macroBenefit2Title }}
            </UiComponentHeading>
            <UiComponentParagraph>{{ data.componentValueProposition.macroBenefit2Text }}</UiComponentParagraph>
          </UiComponentWrapper>
          <UiComponentWrapper class="features">
            <UiComponentWrapper class="feature">
              <UiComponentHeading :level="4">
                {{ data.componentValueProposition.macroBenefit2Feature1Title }}
              </UiComponentHeading>
              <UiComponentParagraph>{{ data.componentValueProposition.macroBenefit2Feature1Text }}</UiComponentParagraph>
              <UiComponentWrapper class="scores">
                <UiComponentWrapper class="score ease-of-use">
                  <UiComponentWrapper class="value">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                    >
                      <path
                        d="M20.0039 1.5C20.0039 0.671571 19.3313 -0.00585784 18.5052 0.0561997C14.2292 0.377424 10.1545 2.06666 6.8959 4.89436C3.25838 8.05084 0.882028 12.4139 0.203432 17.182C-0.475164 21.95 0.589576 26.8028 3.20203 30.8488C5.81449 34.8948 9.7992 37.8622 14.4241 39.2059C19.049 40.5495 24.0034 40.1792 28.3771 38.1629C32.7508 36.1466 36.2501 32.6197 38.232 28.2303C40.2139 23.8409 40.5453 18.8837 39.1654 14.2695C37.9292 10.1359 35.3939 6.52634 31.9557 3.96394C31.2915 3.4689 30.3606 3.68047 29.9167 4.37993C29.4728 5.0794 29.6848 6.00118 30.3424 6.50497C33.1737 8.67388 35.262 11.6879 36.2911 15.1291C37.4641 19.0511 37.1824 23.2647 35.4978 26.9957C33.8131 30.7267 30.8388 33.7246 27.1211 35.4384C23.4035 37.1523 19.1922 37.4671 15.2611 36.325C11.3299 35.1829 7.94291 32.6606 5.72231 29.2215C3.50173 25.7824 2.5967 21.6575 3.1735 17.6047C3.75031 13.5518 5.77021 9.84322 8.8621 7.16021C11.5749 4.80613 14.9531 3.38033 18.5058 3.06611C19.331 2.99312 20.0039 2.32842 20.0039 1.5Z"
                        fill="#2EB89A"
                      />
                    </svg>
                    {{ data.componentValueProposition.macroBenefit2Feature1EaseOfUseValue }}
                  </UiComponentWrapper>
                  <UiComponentParagraph>{{ data.componentValueProposition.macroBenefit2Feature1EaseOfUseText }}</UiComponentParagraph>
                </UiComponentWrapper>
                <UiComponentWrapper class="score ease-of-setup">
                  <UiComponentWrapper class="value">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                    >
                      <path
                        d="M19.9961 1.5C19.9961 0.671573 19.3235 -0.00585641 18.4974 0.0562049C14.2746 0.373435 10.2468 2.02495 7.00713 4.79188C3.38603 7.88459 0.987277 12.1679 0.242326 16.8713C-0.502625 21.5747 0.455119 26.3896 2.94329 30.45C5.43146 34.5103 9.28676 37.5496 13.8158 39.0211C18.3447 40.4927 23.2502 40.3 27.6498 38.4776C32.0493 36.6552 35.6543 33.3228 37.8162 29.0798C39.9782 24.8368 40.5552 19.9616 39.4435 15.3311C38.4489 11.1884 36.1611 7.48477 32.9312 4.74605C32.2994 4.21027 31.3571 4.36297 30.8701 5.03319C30.3832 5.7034 30.5369 6.63666 31.1616 7.18075C33.8169 9.49343 35.6986 12.5835 36.5264 16.0314C37.4713 19.9673 36.9808 24.1113 35.1432 27.7178C33.3056 31.3244 30.2413 34.1569 26.5017 35.706C22.7621 37.255 18.5924 37.4188 14.7428 36.168C10.8932 34.9171 7.61616 32.3338 5.50121 28.8825C3.38627 25.4312 2.57218 21.3385 3.20539 17.3406C3.8386 13.3427 5.87754 9.7019 8.95548 7.0731C11.6518 4.77022 14.9904 3.37635 18.498 3.06611C19.3232 2.99312 19.9961 2.32843 19.9961 1.5Z"
                        fill="#447CFD"
                      />
                    </svg>
                    {{ data.componentValueProposition.macroBenefit2Feature1EaseOfSetupValue }}
                  </UiComponentWrapper>
                  <UiComponentParagraph>{{ data.componentValueProposition.macroBenefit2Feature1EaseOfSetupText }}</UiComponentParagraph>
                </UiComponentWrapper>
                <UiComponentWrapper class="score quality-of-support">
                  <UiComponentWrapper class="value">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="41"
                      height="41"
                      viewBox="0 0 41 41"
                      fill="none"
                    >
                      <path
                        d="M20.1914 2.18359C20.1914 1.35517 19.5188 0.677737 18.6927 0.739799C14.5763 1.04905 10.6425 2.62643 7.44293 5.27333C3.8569 8.23995 1.41775 12.3643 0.54566 16.936C-0.326427 21.5076 0.423152 26.2403 2.66527 30.3187C4.90739 34.3971 8.50166 37.5658 12.8289 39.2791C17.1562 40.9924 21.9455 41.1429 26.3717 39.7047C30.798 38.2665 34.5842 35.3297 37.078 31.4001C39.5718 27.4706 40.617 22.7943 40.0337 18.1769C39.5133 14.0572 37.7254 10.2145 34.9364 7.17113C34.3767 6.56039 33.4226 6.59378 32.8555 7.19767C32.2884 7.80157 32.3239 8.74674 32.8755 9.36484C35.1598 11.9246 36.6244 15.126 37.0574 18.5529C37.5532 22.4777 36.6647 26.4525 34.545 29.7926C32.4253 33.1328 29.207 35.6291 25.4447 36.8516C21.6824 38.074 17.6115 37.9461 13.9333 36.4898C10.2551 35.0335 7.19999 32.34 5.29419 28.8734C3.38839 25.4068 2.75125 21.384 3.49252 17.4981C4.2338 13.6122 6.30707 10.1065 9.3552 7.58487C12.0167 5.38311 15.2759 4.05198 18.6933 3.74971C19.5185 3.67672 20.1914 3.01202 20.1914 2.18359Z"
                        fill="#62AABC"
                      />
                    </svg>
                    {{ data.componentValueProposition.macroBenefit2Feature1QualityOfSupportValue }}
                  </UiComponentWrapper>
                  <UiComponentParagraph>{{ data.componentValueProposition.macroBenefit2Feature1QualityOfSupportText }}</UiComponentParagraph>
                </UiComponentWrapper>
              </UiComponentWrapper>
            </UiComponentWrapper>
            <UiComponentWrapper class="feature">
              <UiComponentHeading :level="4">
                {{ data.componentValueProposition.macroBenefit2Feature2Title }}
              </UiComponentHeading>
              <UiComponentParagraph>{{ data.componentValueProposition.macroBenefit2Feature2Text }}</UiComponentParagraph>
              <UiComponentWrapper class="customization">
                <UiComponentImage
                  :alt="data.componentValueProposition.macroBenefit2Feature2Image.alt"
                  :expected-size="620"
                  :height="data.componentValueProposition.macroBenefit2Feature2Image.height"
                  :source="data.componentValueProposition.macroBenefit2Feature2Image.url"
                  :width="data.componentValueProposition.macroBenefit2Feature2Image.width"
                />
              </UiComponentWrapper>
            </UiComponentWrapper>
          </UiComponentWrapper>
        </UiComponentWrapper>
      </UiComponentWrapper>
      <UiComponentWrapper class="highlighted-features">
        <Transition
          mode="out-in"
          @enter="onEnter"
          @leave="onLeave"
        >
          <UiComponentWrapper
            v-if="currentIndex === 0"
            class="features"
          >
            <UiComponentImage
              :alt="data.componentValueProposition.macroBenefit1Background.alt"
              class="map"
              :expected-size="535"
              :height="data.componentValueProposition.macroBenefit1Background.height"
              :source="data.componentValueProposition.macroBenefit1Background.url"
              :width="data.componentValueProposition.macroBenefit1Background.width"
            />
            <UiComponentWrapper class="feature">
              <UiComponentHeading :level="4">
                {{ data.componentValueProposition.macroBenefit1Feature1Title }}
              </UiComponentHeading>
              <UiComponentParagraph>{{ data.componentValueProposition.macroBenefit1Feature1Text }}</UiComponentParagraph>
              <UiComponentWrapper class="certifications">
                <UiComponentWrapper class="badge gdpr">
                  <UiComponentImage
                    :alt="data.componentValueProposition.macroBenefit1Feature1GdprBadge.alt"
                    :expected-size="72"
                    :height="data.componentValueProposition.macroBenefit1Feature1GdprBadge.height"
                    :source="data.componentValueProposition.macroBenefit1Feature1GdprBadge.url"
                    :width="data.componentValueProposition.macroBenefit1Feature1GdprBadge.width"
                  />
                  <UiComponentParagraph>{{ data.componentValueProposition.macroBenefit1Feature1GdprText }}</UiComponentParagraph>
                </UiComponentWrapper>
                <UiComponentWrapper class="badge iso-27001">
                  <UiComponentImage
                    :alt="data.componentValueProposition.macroBenefit1Feature1Iso27001Badge.alt"
                    :expected-size="72"
                    :height="data.componentValueProposition.macroBenefit1Feature1Iso27001Badge.height"
                    :source="data.componentValueProposition.macroBenefit1Feature1Iso27001Badge.url"
                    :width="data.componentValueProposition.macroBenefit1Feature1Iso27001Badge.width"
                  />
                  <UiComponentParagraph>{{ data.componentValueProposition.macroBenefit1Feature1Iso27001Text }}</UiComponentParagraph>
                </UiComponentWrapper>
              </UiComponentWrapper>
            </UiComponentWrapper>
            <UiComponentWrapper class="feature">
              <UiComponentHeading :level="4">
                {{ data.componentValueProposition.macroBenefit1Feature2Title }}
              </UiComponentHeading>
              <UiComponentParagraph>{{ data.componentValueProposition.macroBenefit1Feature2Text }}</UiComponentParagraph>
              <UiComponentWrapper class="support">
                <UiComponentWrapper class="csat">
                  <UiComponentWrapper class="value">
                    <UiComponentParagraph>{{ data.componentValueProposition.macroBenefit1Feature2CsatText }}</UiComponentParagraph>
                    <UiComponentParagraph>{{ data.componentValueProposition.macroBenefit1Feature2CsatValue }}</UiComponentParagraph>
                  </UiComponentWrapper>
                  <UiComponentWrapper class="bar">
                    <svg
                      class="cursor"
                      xmlns="http://www.w3.org/2000/svg"
                      width="13"
                      height="11"
                      viewBox="0 0 13 11"
                      fill="none"
                    >
                      <path
                        d="M7.10835 10.3328C6.69485 10.9821 5.73351 10.9403 5.37794 10.2576L0.977717 1.80844C0.622144 1.12568 1.13902 0.314036 1.90809 0.34748L11.4254 0.761348C12.1945 0.794792 12.6389 1.64824 12.2254 2.29756L7.10835 10.3328Z"
                        fill="#2EB89A"
                      />
                    </svg>
                  </UiComponentWrapper>
                </UiComponentWrapper>
                <UiComponentWrapper class="nps">
                  <UiComponentWrapper class="value">
                    <UiComponentParagraph>{{ data.componentValueProposition.macroBenefit1Feature2NpsText }}</UiComponentParagraph>
                    <UiComponentParagraph>{{ data.componentValueProposition.macroBenefit1Feature2NpsValue }}</UiComponentParagraph>
                  </UiComponentWrapper>
                  <UiComponentWrapper class="bar">
                    <svg
                      class="cursor"
                      xmlns="http://www.w3.org/2000/svg"
                      width="13"
                      height="11"
                      viewBox="0 0 13 11"
                      fill="none"
                    >
                      <path
                        d="M7.10835 10.3328C6.69485 10.9821 5.73351 10.9403 5.37794 10.2576L0.977717 1.80844C0.622144 1.12568 1.13902 0.314036 1.90809 0.34748L11.4254 0.761348C12.1945 0.794792 12.6389 1.64824 12.2254 2.29756L7.10835 10.3328Z"
                        fill="#2EB89A"
                      />
                    </svg>
                  </UiComponentWrapper>
                </UiComponentWrapper>
                <UiComponentWrapper class="uptime">
                  <UiComponentWrapper class="value">
                    <UiComponentParagraph>{{ data.componentValueProposition.macroBenefit1Feature2UptimeValue }}</UiComponentParagraph>
                    <UiComponentParagraph>{{ data.componentValueProposition.macroBenefit1Feature2UptimeText }}</UiComponentParagraph>
                  </UiComponentWrapper>
                  <UiComponentWrapper class="graph">
                    <UiComponentWrapper
                      v-for="n in 27"
                      :key="`bar-${n}`"
                      class="bar"
                    />
                  </UiComponentWrapper>
                </UiComponentWrapper>
              </UiComponentWrapper>
            </UiComponentWrapper>
          </UiComponentWrapper>
          <UiComponentWrapper
            v-else-if="currentIndex === 1"
            class="features"
          >
            <UiComponentWrapper class="feature">
              <UiComponentHeading :level="4">
                {{ data.componentValueProposition.macroBenefit2Feature1Title }}
              </UiComponentHeading>
              <UiComponentParagraph>{{ data.componentValueProposition.macroBenefit2Feature1Text }}</UiComponentParagraph>
              <UiComponentWrapper class="scores">
                <UiComponentWrapper class="score ease-of-use">
                  <UiComponentWrapper class="value">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                    >
                      <path
                        d="M20.0039 1.5C20.0039 0.671571 19.3313 -0.00585784 18.5052 0.0561997C14.2292 0.377424 10.1545 2.06666 6.8959 4.89436C3.25838 8.05084 0.882028 12.4139 0.203432 17.182C-0.475164 21.95 0.589576 26.8028 3.20203 30.8488C5.81449 34.8948 9.7992 37.8622 14.4241 39.2059C19.049 40.5495 24.0034 40.1792 28.3771 38.1629C32.7508 36.1466 36.2501 32.6197 38.232 28.2303C40.2139 23.8409 40.5453 18.8837 39.1654 14.2695C37.9292 10.1359 35.3939 6.52634 31.9557 3.96394C31.2915 3.4689 30.3606 3.68047 29.9167 4.37993C29.4728 5.0794 29.6848 6.00118 30.3424 6.50497C33.1737 8.67388 35.262 11.6879 36.2911 15.1291C37.4641 19.0511 37.1824 23.2647 35.4978 26.9957C33.8131 30.7267 30.8388 33.7246 27.1211 35.4384C23.4035 37.1523 19.1922 37.4671 15.2611 36.325C11.3299 35.1829 7.94291 32.6606 5.72231 29.2215C3.50173 25.7824 2.5967 21.6575 3.1735 17.6047C3.75031 13.5518 5.77021 9.84322 8.8621 7.16021C11.5749 4.80613 14.9531 3.38033 18.5058 3.06611C19.331 2.99312 20.0039 2.32842 20.0039 1.5Z"
                        fill="#2EB89A"
                      />
                    </svg>
                    {{ data.componentValueProposition.macroBenefit2Feature1EaseOfUseValue }}
                  </UiComponentWrapper>
                  <UiComponentParagraph>{{ data.componentValueProposition.macroBenefit2Feature1EaseOfUseText }}</UiComponentParagraph>
                </UiComponentWrapper>
                <UiComponentWrapper class="score ease-of-setup">
                  <UiComponentWrapper class="value">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                    >
                      <path
                        d="M19.9961 1.5C19.9961 0.671573 19.3235 -0.00585641 18.4974 0.0562049C14.2746 0.373435 10.2468 2.02495 7.00713 4.79188C3.38603 7.88459 0.987277 12.1679 0.242326 16.8713C-0.502625 21.5747 0.455119 26.3896 2.94329 30.45C5.43146 34.5103 9.28676 37.5496 13.8158 39.0211C18.3447 40.4927 23.2502 40.3 27.6498 38.4776C32.0493 36.6552 35.6543 33.3228 37.8162 29.0798C39.9782 24.8368 40.5552 19.9616 39.4435 15.3311C38.4489 11.1884 36.1611 7.48477 32.9312 4.74605C32.2994 4.21027 31.3571 4.36297 30.8701 5.03319C30.3832 5.7034 30.5369 6.63666 31.1616 7.18075C33.8169 9.49343 35.6986 12.5835 36.5264 16.0314C37.4713 19.9673 36.9808 24.1113 35.1432 27.7178C33.3056 31.3244 30.2413 34.1569 26.5017 35.706C22.7621 37.255 18.5924 37.4188 14.7428 36.168C10.8932 34.9171 7.61616 32.3338 5.50121 28.8825C3.38627 25.4312 2.57218 21.3385 3.20539 17.3406C3.8386 13.3427 5.87754 9.7019 8.95548 7.0731C11.6518 4.77022 14.9904 3.37635 18.498 3.06611C19.3232 2.99312 19.9961 2.32843 19.9961 1.5Z"
                        fill="#447CFD"
                      />
                    </svg>
                    {{ data.componentValueProposition.macroBenefit2Feature1EaseOfSetupValue }}
                  </UiComponentWrapper>
                  <UiComponentParagraph>{{ data.componentValueProposition.macroBenefit2Feature1EaseOfSetupText }}</UiComponentParagraph>
                </UiComponentWrapper>
                <UiComponentWrapper class="score quality-of-support">
                  <UiComponentWrapper class="value">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="41"
                      height="41"
                      viewBox="0 0 41 41"
                      fill="none"
                    >
                      <path
                        d="M20.1914 2.18359C20.1914 1.35517 19.5188 0.677737 18.6927 0.739799C14.5763 1.04905 10.6425 2.62643 7.44293 5.27333C3.8569 8.23995 1.41775 12.3643 0.54566 16.936C-0.326427 21.5076 0.423152 26.2403 2.66527 30.3187C4.90739 34.3971 8.50166 37.5658 12.8289 39.2791C17.1562 40.9924 21.9455 41.1429 26.3717 39.7047C30.798 38.2665 34.5842 35.3297 37.078 31.4001C39.5718 27.4706 40.617 22.7943 40.0337 18.1769C39.5133 14.0572 37.7254 10.2145 34.9364 7.17113C34.3767 6.56039 33.4226 6.59378 32.8555 7.19767C32.2884 7.80157 32.3239 8.74674 32.8755 9.36484C35.1598 11.9246 36.6244 15.126 37.0574 18.5529C37.5532 22.4777 36.6647 26.4525 34.545 29.7926C32.4253 33.1328 29.207 35.6291 25.4447 36.8516C21.6824 38.074 17.6115 37.9461 13.9333 36.4898C10.2551 35.0335 7.19999 32.34 5.29419 28.8734C3.38839 25.4068 2.75125 21.384 3.49252 17.4981C4.2338 13.6122 6.30707 10.1065 9.3552 7.58487C12.0167 5.38311 15.2759 4.05198 18.6933 3.74971C19.5185 3.67672 20.1914 3.01202 20.1914 2.18359Z"
                        fill="#62AABC"
                      />
                    </svg>
                    {{ data.componentValueProposition.macroBenefit2Feature1QualityOfSupportValue }}
                  </UiComponentWrapper>
                  <UiComponentParagraph>{{ data.componentValueProposition.macroBenefit2Feature1QualityOfSupportText }}</UiComponentParagraph>
                </UiComponentWrapper>
              </UiComponentWrapper>
            </UiComponentWrapper>
            <UiComponentWrapper class="feature expand">
              <UiComponentHeading :level="4">
                {{ data.componentValueProposition.macroBenefit2Feature2Title }}
              </UiComponentHeading>
              <UiComponentParagraph>{{ data.componentValueProposition.macroBenefit2Feature2Text }}</UiComponentParagraph>
              <UiComponentWrapper class="customization">
                <UiComponentImage
                  :alt="data.componentValueProposition.macroBenefit2Feature2Image.alt"
                  :expected-size="620"
                  :height="data.componentValueProposition.macroBenefit2Feature2Image.height"
                  :source="data.componentValueProposition.macroBenefit2Feature2Image.url"
                  :width="data.componentValueProposition.macroBenefit2Feature2Image.width"
                />
              </UiComponentWrapper>
            </UiComponentWrapper>
          </UiComponentWrapper>
        </Transition>
      </UiComponentWrapper>
    </UiComponentContainer>
  </UiComponentWrapper>
</template>

<script setup>
// Imports
import { gsap } from 'gsap'

// Composables
const { state } = useConditionalPreviewMode()
const { locale } = useI18n()
const { isLogged } = useIsLoggedIn()
const { public: publicRuntimeConfig } = useRuntimeConfig()
const { width: screenWidth } = useScreenSize()

// Async Data
const { data } = await useFetch(`/api/content/components/value-proposition/${locale.value}`, {
  key: `component-value-proposition-${locale.value}`,
  query: {
    preview: state.preview,
  },
})

// Refs
const $root = ref(null)
const currentIndex = ref(0)
const intersectionObserver = ref(null)
const timer = ref(0)

// Variables
let timeline = null

// Computed Properties
const requestDemoCallToAction = computed(() => {
  return {
    action: 'Demo clicked',
    slot: data.value.componentGlobal.ctaGetDemo,
    to: '#form-demo',
  }
})

const signupOrUpgradeCallToAction = computed(() => {
  return isLogged.value
    ? {
        action: 'Upgrade clicked',
        slot: data.value.componentGlobal.ctaUpgradeNow,
        to: `https://${publicRuntimeConfig.appBaseUrl}/#/settings?page=settings&tab=billing`,
      }
    : {
        action: 'Signup clicked',
        slot: data.value.componentGlobal.ctaGetStartedForFree,
        to: `https://${publicRuntimeConfig.appBaseUrl}/#/signup`,
      }
})

// Watchers
watch(
  () => currentIndex.value,
  () => {
    timeline.pause()
    timeline.seek(0)

    nextTick(() => {
      start()
    })
  },
)

// Methods
function createTimeline() {
  timeline = gsap.timeline({
    ease: 'none',
    onComplete,
  })
  timeline.to(
    timer,
    {
      duration: 5,
      ease: 'none',
      value: 100,
    },
  )
  timeline.pause()
}

function onClick(index) {
  if (screenWidth.value < 1328) {
    return
  }

  currentIndex.value = index
}

function onComplete() {
  let index = currentIndex.value + 1
  index %= 2

  currentIndex.value = index
}

function onEnter($element, done) {
  gsap.from($element, {
    autoAlpha: 0,
    duration: 0.6,
    ease: 'expo.out',
    onComplete: () => {
      done()
    },
    xPercent: currentIndex.value === 0 ? -100 : 100,
  })
}

function onLeave($element, done) {
  gsap.to($element, {
    autoAlpha: 0,
    duration: 0.4,
    ease: 'expo.in',
    onComplete: () => {
      done()
    },
    xPercent: currentIndex.value === 0 ? 25 : -25,
  })
}

function onMouseEnter(index) {
  if (currentIndex.value !== index) {
    return
  }

  timeline.pause()
}

function onMouseLeave() {
  start()
}

function onObserve([{ isIntersecting }]) {
  if (isIntersecting) {
    start()
  }
  else {
    timeline.pause()
  }
}

function start() {
  if (screenWidth.value >= 1328) {
    timeline.play()
  }
}

// Lifecycle Hooks
onBeforeUnmount(() => {
  if (intersectionObserver.value) {
    intersectionObserver.value.disconnect()
    intersectionObserver.value = null
  }

  if (timeline) {
    timeline.kill()
    timeline = null
  }
})

onMounted(() => {
  createTimeline()

  intersectionObserver.value = new IntersectionObserver(onObserve)
  intersectionObserver.value.observe($root.value.$el)
})
</script>

<style lang="postcss" scoped>
.value-proposition {
  @apply justify-center py-16 bg-grey-blue-100;

  @screen md {
    @apply py-26;
  }

  .inner {
    @apply flex-col;

    @screen xl {
      @apply relative h-[696px];
    }

    .hero {
      @apply flex-col;

      @screen xl {
        @apply self-start w-span6;
      }

      .h2 {
        @apply font-medium text-2xl leading-8;

        @screen mdminus {
          @apply text-[28px] leading-[34px];
        }

        @screen mdplus {
          @apply text-3xl leading-10;
        }

        :deep(strong) {
          @apply font-medium;
        }

        & + p {
          @apply mt-4 text-grey-blue-600;
        }
      }

      .actions {
        @apply flex-col items-center gap-4 mt-6;

        @screen md {
          @apply flex-row flex-wrap gap-6 w-auto;
        }

        .button {
          @apply w-full;

          @screen md {
            @apply w-auto;
          }
        }
      }
    }

    .benefits {
      @apply flex-col gap-16 mt-20;

      @screen xl {
        @apply gap-14;
      }

      .benefit {
        @apply flex-col;

        &.active {
          .headline {
            @screen xl {
              @apply opacity-100;
            }

            &::after {
              @screen xl {
                @apply h-[var(--timer)];
              }
            }
          }
        }

        &.mastering-engagements {
          .features {
            @apply pb-0;
          }
        }

        &.your-trusted-european-alternative {
          .features {
            @apply gap-16;
          }
        }

        .headline {
          @apply flex-col self-start;

          @screen xl {
            @apply relative max-w-[454px] pl-5 opacity-30 cursor-pointer transition-opacity duration-600 ease-in-out;
          }

          &::before {
            @screen xl {
              @apply absolute left-0 top-0 flex h-full w-1 mr-4 bg-grey-blue-200 content-[''] rounded-[2px];
            }
          }

          &::after {
            @screen xl {
              @apply absolute left-0 top-0 flex h-0 w-1 mr-4 bg-livestorm-blue-700 content-[''] rounded-[2px] z-10;
            }
          }

          .h3 {
            @apply text-xl leading-7;

            @screen mdminus {
              @apply text-2xl leading-8;
            }

            @screen mdplus {
              @apply text-2xl leading-8;
            }

            & + p {
              @apply mt-2 text-grey-blue-600;
            }
          }
        }
      }
    }

    .features {
      @apply relative flex-col gap-12 mt-6 p-6 bg-white rounded-3xl shadow-light3 overflow-hidden;

      @screen md {
        @apply p-14 rounded-4xl;
      }

      @screen xl {
        @apply hidden;
      }

      .map {
        @apply absolute bottom-0 -left-10 z-0 rounded-none;
      }

      .feature {
        @apply flex-col z-10;

        .h4 {
          @apply text-origin leading-7;

          @screen mdminus {
            @apply text-xl;
          }

          @screen mdplus {
            @apply text-xl;
          }

          & + p {
            @apply mt-2 text-grey-blue-600;
          }
        }

        .certifications {
          @apply flex-col gap-[10px] mt-4;

          @screen md {
            @apply flex-row flex-wrap gap-4;
          }

          .badge {
            @apply items-center w-auto;

            & + .badge {
              @apply ml-0;
            }

            picture {
              @apply z-10;
            }

            p {
              @apply flex-shrink-0 -ml-4 pl-6 pr-4 py-[10px] bg-white border border-grey-blue-100 font-medium text-sm leading-6 rounded-xl shadow-light2 overflow-hidden z-0;
            }
          }
        }

        .support {
          @apply relative flex-col justify-end h-[253px] mt-4;

          @screen md {
            @apply h-[147px] mt-2;
          }

          .csat,
          .nps {
            @apply absolute flex-col w-[260px] p-5 bg-white border border-grey-blue-100 rounded-2xl shadow-light2 overflow-hidden transform;

            .value {
              p {
                @apply font-medium text-sm leading-7;

                & + p {
                  @apply ml-1 font-normal text-spring-green-600;
                }
              }
            }

            .bar {
              @apply relative h-2 bg-spring-green-600 rounded-[8px];

              .cursor {
                @apply absolute -top-4 right-0;
              }
            }
          }

          .csat {
            @apply left-0 top-0 -rotate-[1deg];

            @screen md {
              @apply left-[0.22px] top-[10.44px];
            }

            .bar {
              .cursor {
                @apply right-[5.25px];
              }
            }
          }

          .nps {
            @apply left-[49.7px] top-[71px] rotate-[2.5deg];

            @screen md {
              @apply left-[244.68px] top-[0.75px];
            }

            .bar {
              background: linear-gradient(
                to right,
                #F19899,
                #F19899 50%,
                #FEDE76 50%,
                #FEDE76 66.66%,
                #59D4C0 66.66%,
                #59D4C0 83.32%,
                #2EB89A 83.32%,
                #2EB89A
              );

              .cursor {
                @apply right-[19.36px];
              }
            }
          }

          .uptime {
            @apply flex-col gap-2;

            @screen md {
              @apply flex-row-reverse justify-end gap-6;
            }

            .value {
              @screen md {
                @apply w-auto;
              }

              &::before {
                @apply flex flex-shrink-0 self-center h-3 w-3 mr-3 bg-spring-green-700 border border-white content-[''] rounded-full drop-shadow-[0px_0px_8px_rgba(23,166,121,0.60)];
              }

              p {
                @apply font-medium text-2xl leading-7;

                & + p {
                  @apply ml-1 font-normal text-base leading-7;
                }
              }
            }

            .graph {
              @apply gap-1 h-7;

              @screen md {
                @apply w-auto;
              }

              .bar {
                @apply relative self-end h-full w-[5px];

                &::before {
                  @apply absolute bottom-0 left-0 h-7 w-[5px] bg-grey-blue-200 rounded-[5px] z-0 content-[''];
                }

                &::after {
                  @apply absolute bottom-0 left-0 h-7 w-[5px] bg-spring-green-600 rounded-[5px] z-10 content-[''];
                }

                &:nth-child(1),
                &:nth-child(28) {
                  @apply opacity-20;
                }

                &:nth-child(2),
                &:nth-child(27) {
                  @apply opacity-40;
                }

                &:nth-child(3),
                &:nth-child(26) {
                  @apply opacity-60;
                }

                &:nth-child(4),
                &:nth-child(25) {
                  @apply opacity-80;
                }

                &:nth-child(23) {
                  &::after {
                    @apply h-4/5;
                  }
                }

                &:nth-child(22) {
                  &::after {
                    @apply h-2/3;
                  }
                }
              }
            }
          }
        }

        .scores {
          @apply relative h-[174px] mt-2;

          @screen md {
            @apply h-[121px];
          }

          .score {
            @apply absolute items-center gap-3 max-w-[236px] px-4 py-3 bg-white  rounded-2xl shadow-light2 overflow-hidden;

            &.ease-of-use {
              @apply left-0 top-0;

              @screen md {
                @apply left-0 top-[13px];
              }

              .value {
                @apply text-spring-green-600;
              }
            }

            &.ease-of-setup {
              @apply left-[61px] top-[52px] z-10;

              @screen md {
                @apply left-[128px] top-[57px];
              }

              .value {
                @apply text-livestorm-blue-500;
              }
            }

            &.quality-of-support {
              @apply left-4 top-[110px];

              @screen md {
                @apply left-[251.19px] top-0;
              }

              .value {
                @apply text-winter-green-500;
              }
            }

            .value {
              @apply relative h-10 w-10 items-center justify-center font-medium text-base leading-7;

              svg {
                @apply absolute inset-0;
              }
            }

            p {
              @apply font-medium text-base leading-[140%];
            }
          }
        }

        .customization {
          @apply mt-[13px] transform -translate-x-6;

          @screen md {
            @apply mt-auto -translate-x-8;
          }
        }
      }
    }

    .highlighted-features {
      @apply hidden;

      @screen xl {
        @apply absolute right-0 top-0 flex h-[696px] w-span6 bg-white rounded-4xl shadow-light3 overflow-hidden;
      }

      .features {
        @apply flex h-full pb-0 mt-0 bg-none rounded-none shadow-none;

        .feature {
          &.expand {
            @apply self-start h-full;
          }
        }
      }
    }
  }
}
</style>
